import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {APP_BASE_HREF, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {GameViewModule} from './game-view/game-view.module';
import {ErrorComponent} from './error/error.component';
import {SessionService} from './shared/services/session/session.service';
import {TranslationService} from './shared/services/translation/translation.service';
import {HttpModule} from '@angular/http';
import {LoggingService} from './shared/services/logging/logging.service';
import {SignalrService} from './shared/services/signalr/signalr.service';
import {WinningPlanService} from './shared/services/winning-plan/winning-plan.service';
import {BetStartService} from './shared/services/bet-start/bet-start.service';
import {DrawingService} from './shared/services/drawing/drawing.service';
import {BettingModule} from './betting/betting.module';
import {InitialStateService} from './shared/services/initial-state/initial-state.service';
import {LoginService} from './shared/services/login/login.service';
import {BalanceService} from './shared/balance/balance.service';
import {SettingsService} from './shared/services/settings/settings.service';
import {BettingService} from './shared/services/betting/betting.service';
import {DrawingHistoryService} from './shared/services/drawing-history/drawing-history.service';
import {TicketHistoryService} from './shared/services/ticket-history/ticket-history.service';
import {PayinService} from './shared/services/payin/payin.service';
import {PayoutService} from './shared/services/payout/payout.service';
import {InfoBubbleModule} from './info-bubble/info-bubble.module';
import {TransactionListService} from './shared/services/transaction-list/transaction-list.service';
import {JackpotBubbleComponent} from './jackpot-bubble/jackpot-bubble.component';
import {SharedModule} from './shared/shared.module';
import {IdleStateService} from './shared/services/idle-state.service';

export function readCookie(name: string): string {
  let nameEQ: string = name + '=';
  let ca: string[] = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c: string = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function appInitializer(translationService: TranslationService, sessionService: SessionService) {
  return async () => {
    sessionService.isIframe = window.location !== window.parent.location;
    await translationService.init();
  };
};

export function languageFactory() {
  const iframeLang = readCookie('lang');
  if (iframeLang && window.location !== window.parent.location) {
    console.log('in iframe, setting lang', iframeLang);
    return iframeLang ? iframeLang : navigator.language.split('-')[0];
  } else {
    return readCookie('language') ? readCookie('language') : navigator.language.split('-')[0];
  }
}

@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent,
    JackpotBubbleComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    SharedModule,
    AppRoutingModule,
    GameViewModule,
    BettingModule,
    InfoBubbleModule
  ],
  providers: [
    SessionService,
    TranslationService,
    LoggingService,
    SignalrService,
    WinningPlanService,
    BetStartService,
    DrawingService,
    InitialStateService,
    LoginService,
    IdleStateService,
    BalanceService,
    SettingsService,
    BettingService,
    DrawingHistoryService,
    TicketHistoryService,
    PayinService,
    PayoutService,
    TransactionListService,
    {
      provide: LOCALE_ID,
      useFactory: languageFactory
    },
    {
      provide: ErrorHandler,
      useClass: ErrorComponent
    },
    {
      provide: APP_BASE_HREF,
      useValue: '/'
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      deps: [TranslationService, SessionService],
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/app.module.ts